export const HOT_LIST = {
  台北車站: {
    name: "台北車站",
    name_en: "Taipei Main Station",
    place_id: "ChIJUZ-WfXKpQjQR0j4ggToD89A",
    address_detail: "台北市中正區",
  },
  高鐵左營站: {
    name: "高鐵左營站",
    name_en: "Zuoying HSR Station",
    place_id: "ChIJaQo7MXAFbjQRpzEfQvnAH2A",
    address_detail: "高雄市左營區",
  },
  高鐵台中站: {
    name: "高鐵台中站",
    name_en: "Taichung HSR Station",
    place_id: "ChIJPRMcx6E-aTQRtOhWPerjwEw",
    address_detail: "台中市烏日區",
  },
  台南火車站前站: {
    name: "台南火車站前站",
    name_en: "Tainan Station (Front)",
    place_id: "ChIJL169fRp3bjQR6dOuxj52S8U",
    address_detail: "台南市中西區",
  },
  桃園火車站: {
    name: "桃園火車站",
    name_en: "Taoyuan Station",
    place_id: "ChIJP6yUReMeaDQRe0qiarE5rIw",
    address_detail: "桃園市桃園區",
  },
  板橋火車站: {
    name: "板橋火車站",
    name_en: "Banqiao Station",
    place_id: "ChIJxY8oQhmoQjQRL2QVDJmNDgc",
    address_detail: "新北市板橋區",
  },
  松山機場: {
    name: "松山機場",
    name_en: "Songshan Airport",
    place_id: "ChIJWSYUpPGrQjQROop1ttwNGJM",
    address_detail: "台北市松山區",
  },
  西門町: {
    name: "西門町",
    name_en: "Ximending",
    place_id: "ChIJKyaoGAmpQjQR99RS3zrx9Ms",
    address_detail: "台北市萬華區",
  },
  萬華: {
    name: "萬華",
    name_en: "Wanhua",
    place_id: "ChIJyR5dkLGpQjQRuNNGn4w3vSo",
    address_detail: "台北市萬華區",
  },
};

export const ZONE_LIST = {
  台北: {
    show_name: "台北",
    name: "台北車站",
    name_en: "Taipei Main Station",
    place_id: "ChIJUZ-WfXKpQjQR0j4ggToD89A",
    address_detail: "台北市中正區",
  },
  新北: {
    show_name: "新北",
    name: "板橋車站",
    name_en: "Banqiao Station",
    place_id: "ChIJZ04iahmoQjQRYplylv-In-w",
    address_detail: "新北市板橋區",
  },
  桃園: {
    show_name: "桃園",
    name: "桃園火車站",
    name_en: "Taoyuan HSR Station",
    place_id: "ChIJP6yUReMeaDQRe0qiarE5rIw",
    address_detail: "桃園市桃園區",
  },
  新竹: {
    show_name: "新竹",
    name: "新竹火車站",
    name_en: "Hsinchu Station",
    place_id: "ChIJBXLgwuk1aDQRuu4aKYS0jF4",
    address_detail: "新竹市東區",
  },
  台中: {
    show_name: "台中",
    name: "台中高鐵站",
    name_en: "Taichung HSR Station",
    place_id: "ChIJPRMcx6E-aTQRtOhWPerjwEw",
    address_detail: "台中市烏日區",
  },
  彰化: {
    show_name: "彰化",
    name: "彰化火車站",
    name_en: "Changhua Station",
    place_id: "ChIJH3GYEJo4aTQR0MidCJ9ycko",
    address_detail: "彰化縣彰化市",
  },
  嘉義: {
    show_name: "嘉義",
    name: "嘉義火車站",
    name_en: "Chiayi Station",
    place_id: "ChIJd9Ol1iiUbjQRSqih51blxL0",
    address_detail: "嘉義市東區",
  },
  台南: {
    show_name: "台南",
    name: "台南火車站",
    name_en: "Tainan Station",
    place_id: "ChIJCaqM84x2bjQRRqzST46i6cM",
    address_detail: "台南市中西區",
  },
  高雄: {
    show_name: "高雄",
    name: "高雄火車站",
    name_en: "Kaohsiung Station",
    place_id: "ChIJpwcdh_QEbjQRSealHm8pucw",
    address_detail: "高雄市前金區",
  },
  屏東: {
    show_name: "屏東",
    name: "屏東火車站",
    name_en: "Pingtung Station",
    place_id: "ChIJ3xIF6IMXbjQReTq6k5oBkqc",
    address_detail: "屏東縣屏東市",
  },
  台東: {
    show_name: "台東",
    name: "台東火車站",
    name_en: "Taitung Station",
    place_id: "ChIJWTRdEi26bzQRYblctx9f4Wo",
    address_detail: "台東縣台東市",
  },
  花蓮: {
    show_name: "花蓮",
    name: "花蓮火車站",
    name_en: "Hualien Station",
    place_id: "ChIJK6-HgbafaDQR99QetgTFgwU",
    address_detail: "花蓮縣花蓮市",
  },
  宜蘭: {
    show_name: "宜蘭",
    name: "宜蘭火車站",
    name_en: "Yilan Station",
    place_id: "ChIJZXcpx9vkZzQRyqac8zBfg1Y",
    address_detail: "宜蘭縣宜蘭市",
  },
  基隆: {
    show_name: "基隆",
    name: "基隆火車站",
    name_en: "Keelung Station",
    place_id: "ChIJK17Q2BROXTQRUAheqvBKqj4",
    address_detail: "基隆市仁愛區",
  },
};

export const ZHUYIN_TABLE = [
  "ㄅ",
  "ㄆ",
  "ㄇ",
  "ㄈ",
  "ㄉ",
  "ㄊ",
  "ㄋ",
  "ㄌ",
  "ㄍ",
  "ㄎ",
  "ㄏ",
  "ㄐ",
  "ㄑ",
  "ㄒ",
  "ㄓ",
  "ㄔ",
  "ㄕ",
  "ㄖ",
  "ㄗ",
  "ㄘ",
  "ㄙ",
  "ㄧ",
  "ㄨ",
  "ㄩ",
  "ㄚ",
  "ㄛ",
  "ㄜ",
  "ㄝ",
  "ㄞ",
  "ㄟ",
  "ㄠ",
  "ㄡ",
  "ㄢ",
  "ㄣ",
  "ㄤ",
  "ㄥ",
  "ㄦ",
  "ˇ",
  "ˋ",
  "ˊ",
  "˙",
];

export const getStationsInRange = async (center, stationZones) => {
  return (
    stationZones
      // step 1: 簡單篩選 10 公里內的站點
      .filter((item) => {
        return (
          item.lat < center[0] + 0.09 &&
          item.lat > center[0] - 0.09 &&
          item.lng < center[1] + 0.09 &&
          item.lng > center[1] - 0.09
        );
      })
      // step 2: 計算詳細距離
      .map((item) => {
        const centerLatLng = new google.maps.LatLng(center[0], center[1]);
        const stationLatLng = new google.maps.LatLng(item.lat, item.lng);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(
          centerLatLng,
          stationLatLng
        );
        return {
          ...item,
          distance: distance / 1000,
        };
      })
      .filter((item) => {
        // 設定 10 公里內的站點
        return item.distance < 10;
      })
      // 按照距離排序
      .sort((a, b) => {
        return a.distance - b.distance;
      })
  );
};

export const getDistance = async (center, stationZones) => {
  return stationZones
    .map((item) => {
      const centerLatLng = new google.maps.LatLng(center[0], center[1]);
      const stationLatLng = new google.maps.LatLng(item.lat, item.lng);
      const distance = google.maps.geometry.spherical.computeDistanceBetween(
        centerLatLng,
        stationLatLng
      );
      return {
        ...item,
        distance: distance / 1000,
      };
    })
    .sort((a, b) => {
      return a.distance - b.distance;
    });
};

export const getSearchHistory = async () => {
  return JSON.parse(localStorage.getItem("searchHistory")) || [];
};

export const deleteHistory = async (placeId) => {
  const searchHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];
  const isExist = searchHistory.find((item) => item.place_id === placeId);
  if (isExist) {
    searchHistory.splice(searchHistory.indexOf(isExist), 1);
  }
  localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
  return searchHistory;
};

export const setSearchHistory = async (searchAddress, placeId) => {
  // 搜尋時儲存搜尋地址和 placeId 在 localstorage，最多兩筆
  const searchHistory = JSON.parse(localStorage.getItem("searchHistory")) || [];

  const isExist = searchHistory.find(
    (item) => item.place_id === placeId || item.name === searchAddress
  );

  if (isExist) {
    searchHistory.splice(searchHistory.indexOf(isExist), 1);
  }

  if (searchHistory.length >= 2) {
    searchHistory.shift();
  }

  const addressDetail = ZONE_LIST[searchAddress]?.address_detail;

  searchHistory.push({
    name: searchAddress,
    place_id: placeId,
    detail: addressDetail,
  });
  localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
};


